import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import AboutUs from '@/pages/about-us/about-us'
import Orthodontics from '@/pages/orthodontics/orthodontics'
import PedDentistry from '@/pages/ped-dentistry/ped-dentistry'
import NewsEvents from '@/pages/news-events/news-events'
import Faq from '@/pages/faq/faq'
import Blog from '@/pages/blog/blog'
import Sponsorships from '@/pages/sponsorships/sponsorships'
import ContactUs from '@/pages/contact-us/contact-us'
import Smileassessment from '@/pages/smile-assessment/smile-assessment'
import Braces101 from '@/pages/braces-101/braces-101'
import ThankYou from '@/pages/thank-you/thank-you'
import TheGift from '@/pages/the-gift-of-a-smile/the-gift-of-a-smile'
import Accessibility from '@/pages/accessibility/accessibility'
import BlogPost from '@/pages/blog-post/blog-post'
import SingleNewsEvent from '@/pages/single-news-event/single-news-event'
import geneLReeseScholarshipEndowment from '@/pages/gene-l-reese-scholarship-endowment/gene-l-reese-scholarship-endowment'
// import PageNotFound from '@/pages/404/404'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      description: 'Home page description',
      component: Home
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: AboutUs
    },
    {
      path: '/Sponsorships',
      name: 'sponsorships',
      navigation: true,
      component: Sponsorships
    },
    {
      path: '/orthodontics',
      name: 'orthodontics',
      component: Orthodontics
    },
    {
      path: '/pediatric-dentistry',
      name: 'pediatric-dentistry',
      component: PedDentistry
    },
    {
      path: '/news-events',
      name: 'news-events',
      component: NewsEvents
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    {
      path: '/blog',
      name: 'blog',
      navigation: false,
      component: Blog
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs
    },
    {
      path: '/smile-assessment',
      name: 'Smile assessment',
      navigation: false,
      component: Smileassessment
    },
    {
      path: '/braces-101',
      name: 'Braces 101',
      navigation: false,
      component: Braces101
    },
    {
      path: '/thank-you',
      name: 'Thank You',
      navigation: false,
      component: ThankYou
    },
    {
      path: '/gene-l-reese-scholarship-endowment',
      name: 'gene L Reese Scholarship Endowment',
      navigation: false,
      component: geneLReeseScholarshipEndowment
    },
    {
      path: '/the-gift-of-a-smile',
      name: 'The Gift',
      navigation: true,
      component: TheGift
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '/news-events/:event',
      component: SingleNewsEvent
    },
    {
      path: '/blog-post/:id',
      name: 'BlogPost',
      component: BlogPost
    }
    // {
    //   path: '*',
    //   name: 'redirect',
    //   component: Home
    // }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js